/**
 * Created by JasonChou on 17/2/22.
 */
const state = {
  info: null,
  tables: [],
  i18ns: [],
  ossList: [],
  privatizationDeployStatus: false, // 私有化部署状态
};

const mutations = {
  SELECT_PROJECT (state, project) {
    state.info = project;
  },

  INIT_TABLES (state, tables) {
    state.tables = tables;
  },

  INIT_OSSES (state, ossList) {
    state.ossList = ossList;
  },

  UPDATE_TABLES_CACHE (state, tableID, table) {
    let index = state.tables.findIndex(table => table.table_id == tableID);
    if (index === -1) {
      state.tables.push(table);
    } else {
      if (table) {
        state.tables[index] = table;
      } else {
        state.tables.splice(index, 1);
      }
    }
  },

  UPDATE_OSSES_CACHE (state, uuid, oss) {
    let index = state.ossList.findIndex(oss => oss.uuid == uuid);
    if (index === -1) {
      state.ossList.push(oss);
    } else {
      if (oss) {
        state.ossList[index] = oss;
      } else {
        state.ossList.splice(index, 1);
      }
    }
  },


  INIT_I18N (state, i18ns) {
    i18ns.forEach((item) => {
      item.isEdit = false;
    });
    state.i18ns = i18ns;
  },

  ADD_I18N (state, item) {
    state.i18ns.push(item);
  },

  UPDATE_I18N (state, i18nItem) {
    state.i18ns.forEach((item) => {
      if (item._id === i18nItem._id) {
        item = i18nItem;
      }
    });
  },

  INIT_PROJECT_INFO (state, project) {
    state.info = project;
  },

  CHANGE_DEPLOY_STATUS (state, status) {
    state.privatizationDeployStatus = status;
  },

  CHANGE_PROJECT_SMS_TEMPLATES (state, templates) {
    state.info.sms.templates = templates
  }
};


export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/stores/project.js